document.addEventListener("DOMContentLoaded", () => {
    productAvailableToggle();
    rocketIconVisible();
})

function productAvailableToggle() {
    document.querySelector('.product-available-address-toggle-btn.show').addEventListener('click', (e) => {
        e.preventDefault()
        document.querySelector(".product-available-address-wrapper").classList.add('show');
        document.querySelector('body').classList.add('overflow-hidden')
        document.querySelector('.shopify-section-group-header-group.section-header').classList.add('shopify-section-header-hidden')
    })
    document.querySelector('.product-available-address-toggle-btn.hide').addEventListener('click', (e) => {
        e.preventDefault()
        document.querySelector(".product-available-address-wrapper").classList.remove('show');
        document.querySelector('body').classList.remove('overflow-hidden')
    })
    document.querySelector('.product-available-address_overlay').addEventListener('click', (e) => {
        e.preventDefault()
        document.querySelector(".product-available-address-wrapper").classList.remove('show');
        document.querySelector('body').classList.remove('overflow-hidden')
    })
}

function rocketIconVisible() {
    document.querySelectorAll('.rocket_icon').forEach(element => {
        fetch(`/products/${element.getAttribute('product-handle')}?variant=${element.getAttribute('variant-id')}&view=variant-rocket-icon`, {
        }).then(response => {
            return response.text()
        }).then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            element.innerHTML = html.querySelector('.rocket_icon').innerHTML;
        })
    })
}